import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import LoadingWrapper from 'components/LoadingWrapper';
import intl from 'i18n/intl';
// REDUX
import { useAppDispatch } from 'slices/store';
import { DefaultContentLayout } from '@timeedit/ui-components';
// COMPONENTS
import AddNewObjectType from '../../../components/AppService/ObjectTypes/AddNewObjectTypes';
import ObjectTypeMapping from '../../../components/AppService/ObjectTypes/ObjectTypeMapping';
import {
  appServiceReportLoading,
  appServiceReportObjectTypes,
  fetchReportMappingSettings,
} from '../../../slices/appService.slice';

const language: any = intl.messages;

const ObjectTypes = () => {
  const dispatch = useAppDispatch();
  // Store local copy of integration settings in component state
  const storeResource = useSelector(appServiceReportObjectTypes);
  const loading = useSelector(appServiceReportLoading);
  const [resource, setResource] = useState(storeResource);
  /**
   * EFFECTS
   */
  useEffect(() => {
    setResource(storeResource);
  }, [storeResource]);
  useEffect(() => {
    dispatch(fetchReportMappingSettings());
  }, []);

  /**
   * EVENT HANDLERS
   */

  return (
    <DefaultContentLayout
      title={language.report_settings}
      subtitle={language.manage_mapping}
    >
      <LoadingWrapper isLoading={loading}>
        <div
          className="inner-content--wrapper allow-scroll"
          style={{ padding: '15px', display: 'block' }}
        >
          <AddNewObjectType
            appName={'teReporting'}
            objectTypes={resource}
            allowedMappingModes={['FREE_MAPPING']}
          />
          {resource.map((objectType: any, objectTypeIdx: number) => (
            <ObjectTypeMapping
              key={objectType.applicationObjectTypeName}
              objectType={objectType}
              appName={'teReporting'}
              allowedMappingModes={['FREE_MAPPING']}
              objectTypeIdx={objectTypeIdx}
              showPreview={objectType.status === 'TESTED'}
            />
          ))}
        </div>
      </LoadingWrapper>
    </DefaultContentLayout>
  );
};

export default ObjectTypes;
